/**
 * @fileoverview å¤æ­ç¹æ¯å¦å¨å¤è¾¹å½¢å
 * @author dxq613@gmail.com
 */
// å¤è¾¹å½¢çå°çº¿æ£æµï¼åèï¼https://blog.csdn.net/WilliamSun0122/article/details/77994526
var tolerance = 1e-6;
// ä¸æå½æ°ï¼å¤æ­ä¸¤ä¸ªdoubleå¨epsç²¾åº¦ä¸çå¤§å°å³ç³»
function dcmp(x) {
    if (Math.abs(x) < tolerance) {
        return 0;
    }
    return x < 0 ? -1 : 1;
}
// å¤æ­ç¹Qæ¯å¦å¨p1åp2ççº¿æ®µä¸
function onSegment(p1, p2, q) {
    if ((q[0] - p1[0]) * (p2[1] - p1[1]) === (p2[0] - p1[0]) * (q[1] - p1[1]) &&
        Math.min(p1[0], p2[0]) <= q[0] &&
        q[0] <= Math.max(p1[0], p2[0]) &&
        Math.min(p1[1], p2[1]) <= q[1] &&
        q[1] <= Math.max(p1[1], p2[1])) {
        return true;
    }
    return false;
}
// å¤æ­ç¹På¨å¤è¾¹å½¢å-å°çº¿æ³
export default function isInPolygon(points, x, y) {
    var isHit = false;
    var n = points.length;
    if (n <= 2) {
        // svg ä¸­ç¹å°äº 3 ä¸ªæ¶ï¼ä¸æ¾ç¤ºï¼ä¹æ æ³è¢«æ¾å
        return false;
    }
    for (var i = 0; i < n; i++) {
        var p1 = points[i];
        var p2 = points[(i + 1) % n];
        if (onSegment(p1, p2, [x, y])) {
            // ç¹å¨å¤è¾¹å½¢ä¸æ¡è¾¹ä¸
            return true;
        }
        // åä¸ä¸ªå¤æ­min(p1[1],p2[1])<P.y<=max(p1[1],p2[1])
        // åä¸ä¸ªå¤æ­è¢«æµç¹ å¨ å°çº¿ä¸è¾¹äº¤ç¹ çå·¦è¾¹
        if (dcmp(p1[1] - y) > 0 !== dcmp(p2[1] - y) > 0 &&
            dcmp(x - ((y - p1[1]) * (p1[0] - p2[0])) / (p1[1] - p2[1]) - p1[0]) < 0) {
            isHit = !isHit;
        }
    }
    return isHit;
}
//# sourceMappingURL=point-in-polygon.js.map